<template>
  <b-modal
    ref="modal"
    cancel-variant="info"
    header-bg-variant="secondary"
    footer-bg-variant="secondary"
    header-text-variant="white"
    :size="data.size || 'md'"
    :title="_trans('Render Farm Manager')"
    :centered="data.centered || false"
    :scrollable="data.scrollable || false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template slot="modal-header-close">
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      ></b-button>
    </template>
    <input
      v-model="renderName"
      type="text"
      class="form-control"
      :placeholder="_trans('Render name')"
    />
    <div slot="modal-footer">
      <b-button
        variant="primary"
        @click="sendRender()"
        v-html="_trans('Send render')"
      ></b-button>
    </div>
  </b-modal>
</template>
<script>
    import dmodalRenderfarm from "@dialogs/modalRenderfarm";

    export default {
        mixins: [dmodalRenderfarm]
    };
</script>



// WEBPACK FOOTER //
// src/custom/mepsaws/dialogs/modalRenderfarm.vue